<template>
  <div>
    <div class="mb-2 flex justify-end">
      <ExportMenu :disabled="!rowData.length" :exports="[{ type: 'excel', action: exportToExcel }]" />
    </div>
    <div :class="[!autoHeight ? 'h-96' : '']"  >
      <AgGridVue
        :key="tableKey"
        :theme="standardListTheme"
        style="width: 100%; height: 100%"
        :column-defs="computedColumnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :auto-group-column-def="autoGroupColumnDef"
        :group-display-type="groupDisplayType"
        :grid-options="gridOptions"
        :loading="loading"
        @grid-ready="onGridReady"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { AgGridVue } from 'ag-grid-vue3'
import { standardListTheme } from '@/utils/common'
import {exportToExcel} from '@/utils/exportArraytoXlsx';
import CC_Router_Link_To_Object from '@/components/widgetcomponents/AG_Grid_Custom_Cells/CC_Router_Link_To_Object.vue';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue'

export default {
  components: {
    AgGridVue,
    ExportMenu,
  },
  props: {
    autoHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    grouperColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      gridApi: null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight' : null,
      },
      loading: true,
      groupDisplayType: 'singleColumn',
      defaultColDef: {
        autoHeight: true,
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellClass: 'cell-theme-left-aligned',
      },
      autoGroupColumnDef: {
        headerName: 'Workflow Type',
        cellClass:'',
        cellRendererParams: {
          suppressCount: true,
        },
      },
      rowData: [],
      tableKey: 0,
    }
  },
  computed: {
    standardListTheme() {
      return standardListTheme
    },
    computedColumnDefs() {
      return [
        {
          headerName: 'Survey Type Name',
          field: 'survey_type_name',
          sortable: false,
          maxWidth: 150,
          filter: false,
          rowGroup:true,
          hide:true
        },
        {
          headerName: 'Survey Question',
          field: 'survey_question_text',
          sortable: false,
          filter: false,
          rowGroup:true,
          hide:true
        },
        {
          headerName: 'Insight_Overview',
          field: 'survey_question_insight',
          sortable: false,
          rowGroup:true,
          hide:true,
          filter: false,
        },
        {
          field: 'survey_question_index',
          hide:true,
          aggFunc:'first',
          sort:'asc'
        },
        {
          headerName: 'Practices in Category',
          wrapText: true,
          autoHeight: true,
          field: 'survey_practice_name',
          sortable: false,
          filter: false,
          cellRenderer: CC_Router_Link_To_Object,
          cellRendererParams: {
            dataType: 'surveyresponse',
          },
        },
        {
          headerName: 'Practice Response',
          wrapText: true,
          autoHeight: true,
          field: 'survey_question_response',
          sortable: false,
          filter: false,
          valueFormatter: (params) => {
            return params.value !== undefined && params.value !== null ? String(params.value) : '';
          }
        },
      ]
    },
  },
  methods: {
    async onGridReady(params) {
      this.gridApi = params.api

      try {
        const response = await axios.get(
          'api/surveys/question-summary/',
        );

        if (response.data?.rowData?.length > 0) {
          this.rowData = response.data.rowData;
        } else {
          this.rowData = [];
        }

        this.loading = false;

        params.api.sizeColumnsToFit();
        window.addEventListener('resize', this.onWindowResize);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit()
      }
    },
    async exportToExcel() {
      this.loading = true

      try {
        const response = await axios.get(
          'api/surveys/question-summary/',
        )
        if (response.data?.rowData) {
          const allData = response.data.rowData
          await exportToExcel(allData,'Workflow_Survey_Data.xlsx')

        } else {
          console.warn('No data to export')
        }
      } catch (error) {
        console.error('Error exporting data:', error)
      } finally {
        this.loading = false
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
  },
}
</script>
